import { useLocation, useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import { getProfile } from "../utils/pip";
import { adminPaths } from "../routes/admin";
import LogoutConfirmationModal from "../components/Modals/common/webinar/LogoutConfirmationModal";
import { enterPrisesPaths } from "../routes/enterprises";

const AdminLayout = ({ children, user }) => {
  const { pathname } = useLocation();
  const navigate = useNavigate();
  const [adminProfile, setAdminProfile] = useState(
    user || getProfile("admin") || {}
  );
  const adminImage =
    adminProfile?.image ||
    adminProfile?.profile_image ||
    "/assets/img/user_profile.png";
  const composedName = [adminProfile?.first_name, adminProfile?.last_name]
    .filter(Boolean)
    .join(" ")
    .trim();
  const adminName =
    adminProfile?.full_name ||
    adminProfile?.name ||
    composedName ||
    adminProfile?.email ||
    "";

  useEffect(() => {
    if (user) {
      setAdminProfile(user);
      return;
    }
    setAdminProfile(getProfile("admin") || {});
  }, [user]);

  useEffect(() => {
    const handleProfileUpdate = () => {
      setAdminProfile(getProfile("admin") || {});
    };
    window.addEventListener("admin-profile-updated", handleProfileUpdate);
    return () => {
      window.removeEventListener("admin-profile-updated", handleProfileUpdate);
    };
  }, []);

  const handleLogout = () => {
    localStorage.removeItem("admin_token_nuvio");
    localStorage.removeItem("createBootCampFormData");
    navigate(enterPrisesPaths?.Enterprise);
  };

  return (
    <>
      <div class="ct_dash_header ct_px_40">
        <div class="ct_dash_logo">
          <img src="/assets/img/Nuvio_logo.png" alt="" />
        </div>
        <ul class="ct_right_dash_option">
          <li>
            <a>
              <i class="fa-solid fa-bell"></i>
            </a>
          </li>
          <li>
            <div class="ct_right_dropdown dropdown">
              <button
                id="dropdownMenuButton"
                data-bs-toggle="dropdown"
                aria-expanded="false"
              >
                <div class="d-flex align-items-center">
                  <img
                    src={adminImage}
                    alt=""
                    class="ct_img_30"
                  />
                  {adminName ? <span class="ms-2">{adminName}</span> : null}
                </div>
                <i class="fa-solid fa-angle-down ms-auto"></i>
              </button>
              <ul class="dropdown-menu" aria-labelledby="dropdownMenuButton1">
                <li>
                  <a
                    class="dropdown-item"
                    onClick={() =>
                      navigate(adminPaths?.Setting, {
                        state: { tab: "Profile" },
                      })
                    }
                  >
                    My Profile
                  </a>
                </li>
                <li>
                  <a
                    class="dropdown-item"
                    onClick={() =>
                      navigate(adminPaths?.Setting, {
                        state: { tab: "Security" },
                      })
                    }
                  >
                    Change Password
                  </a>
                </li>
                <li>
                  <a
                    class="dropdown-item"
                    data-bs-toggle="modal"
                    data-bs-target="#ct_logout_admin"
                  >
                    Log Out
                  </a>
                </li>
              </ul>
            </div>
          </li>
        </ul>
      </div>
      <div class="ct_dash_nav ct_px_40">
        <ul>
          <li>
            <a
              onClick={() => navigate(adminPaths?.Dashboard)}
              className={pathname == adminPaths?.Dashboard ? "active" : ""}
            >
              Dashboard
            </a>
          </li>
          <li>
            <a
              onClick={() => navigate(adminPaths?.Users)}
              className={pathname == adminPaths?.Users ? "active" : ""}
            >
              Users
            </a>
          </li>
          <li>
            <a
              onClick={() => navigate(adminPaths.AdminContent)}
              className={pathname == adminPaths.AdminContent ? "active" : ""}
            >
              Content
            </a>
          </li>
          <li>
            <a
              onClick={() => navigate(adminPaths.JobProject)}
              className={pathname == adminPaths.JobProject ? "active" : ""}
            >
              Projects & Jobs
            </a>
          </li>
          <li>
            <a
              onClick={() => navigate(adminPaths.Community)}
              className={pathname == adminPaths?.Community ? "active" : ""}
            >
              Community
            </a>
          </li>
          <li>
            <a
              onClick={() => navigate(adminPaths?.Events)}
              className={pathname == adminPaths?.Events ? "active" : ""}
            >
              Events
            </a>
          </li>
          <li>
            <a
              onClick={() => navigate(adminPaths?.Services)}
              className={pathname == adminPaths?.Services ? "active" : ""}
            >
              Services
            </a>
          </li>
          <li>
            <a
              onClick={() => navigate(adminPaths.Report)}
              className={pathname == adminPaths?.Report ? "active" : ""}
            >
              Reports
            </a>
          </li>
          <li>
            <a
              onClick={() => navigate(adminPaths.SupportTicket)}
              className={pathname == adminPaths?.SupportTicket ? "active" : ""}
            >
              Support Ticket
            </a>
          </li>
          <li>
            <a
              onClick={() => navigate(adminPaths.Messaging)}
              className={pathname == adminPaths?.Messaging ? "active" : ""}
            >
              Messaging
            </a>
          </li>
          <li>
            <a
              onClick={() => navigate(adminPaths.Payment)}
              className={pathname == adminPaths?.Payment ? "active" : ""}
            >
              Payment
            </a>
          </li>
          <li>
            <a
              onClick={() => navigate(adminPaths.Setting)}
              className={pathname == adminPaths?.Setting ? "active" : ""}
            >
              Setting
            </a>
          </li>
        </ul>
      </div>
      {children}
      <LogoutConfirmationModal
        id="ct_logout_admin"
        title="Logout"
        onConfirm={handleLogout}
      />
    </>
  );
};

export default AdminLayout;

